module.exports = __webpack_public_path__ + "static/media/end_of_chapter_background.6061b602.png";